const seo = (button, body) => {
  $(document).on('click', button, function (e) {
    e.preventDefault();
    $(body).toggleClass('is-open')
  })
}

export default seo;
